import { h } from "preact";
import { useEffect, useState } from "preact/hooks";

export default function SearchComponent (props) {

    const SEARCH_LENGTH_LIMIT = 1;

    const [string, setString] = useState('');
    const [data, setData] = useState({});
    const [dataStorage, setDataStorage] = useState({});

    const translations = {
        search: window.Drupal.t('Search')
    }

    useEffect(() => {
        // fetch data once
        if (!props.fetchedData) {
            jQuery.post('/glossary-terms/get').then(
                data => {
                    setData(data);
                    setDataStorage(data);
                    props.updateFetchedData();
                    props.updateTerms(data);
                }
            )
        }
    }, []);

    /**
     * Filter data using given user string
     * @returns {{}}
     */
    const filterDataByTitle = () => {
        let filteredData = {};
        Object.keys(dataStorage).forEach(item => {
            // filter regex for each title
            let temp = dataStorage[item].filter(
                term => (new RegExp(string.toLowerCase())).test(term.title.toLowerCase())
            )
            // only add letter with results if that letter has filtered terms
            if (temp.length > 0) {
                filteredData[item] = temp;
            }
        });

        return filteredData;
    }

    /**
     * filter and update terms list on each input string change
     */
    useEffect(() => {
        // filter only if required amount chars is entered
        if (string.length > SEARCH_LENGTH_LIMIT) {
            let filteredData = filterDataByTitle();
            setData(filteredData);
            props.updateTerms(filteredData);
        } else {
            setData(dataStorage);
            props.updateTerms(dataStorage);
        }
    }, [string]);

    /**
     * @param event
     */
    function changedText(event) {
        setString(event.target.value);
    }

    return (
        <div className="glossary-term__search-bar background-color background-color--light-blue">
            <input name="glossary_search" onKeyUp={changedText} onKeyDown={changedText} placeholder={translations.search} id="glossary_search" type="text" className="text"/>
        </div>
    );
}
